/**
 * Angular imports.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { PipesModule } from '../pipes/pipes.module';

/**
 * Component imports.
 */
import { StoryVideoComponent } from '../stories/components/story-video/story-video.component';
import { CustomTemplateComponent } from './components/custom-template/custom-template.component';
import { CreationOptionsComponent } from './components/creation-options/creation-options.component';
import { CreationTextingComponent } from './components/creation-texting/creation-texting.component';
import { CustomComponentComponent } from './components/custom-component/custom-component.component';
import { DeleteModalComponent } from './components/delete-modal/delete-modal.component';
import { MultipleButtonFooterComponent } from './components/multiple-button-footer/multiple-button-footer.component';
import { ProfileBasicHeaderComponent } from './components/profile-basic-header/profile-basic-header.component';
import { ProfileHighlighterComponent } from './components/profile-highlighter/profile-highlighter.component';
import { StoryImageComponent } from './components/story-image/story-image.component';
import { MetaGeneratorComponent } from './components/meta-generator/meta-generator.component';
import { UserViewsListComponent } from './components/user-views-list/user-views-list.component';
import { MultiGesturesComponent } from './components/multi-gestures/multi-gestures.component';
import { ThumbnailViewsComponent } from './components/thumbnail-views/thumbnail-views.component';
import { NoInfoAvailableComponent } from './components/no-info-available/no-info-available.component';
import { UserStoryProductCardComponent } from './components/user-story-product-card/user-story-product-card/user-story-product-card.component';

/**
 * Module imports.
 */
import { DirectivesModule } from '../directives/directives.module';
import { NgbModalModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ModalModule } from 'ngx-bootstrap/modal';
import { UserReactionComponent } from './components/user-reaction/user-reaction/user-reaction.component';
import { ReactionAnimationComponent } from './components/user-reaction/reaction-animation/reaction-animation/reaction-animation.component';
import { WebinarCardModule } from '../webinar/webinar-list/webinar-section/webinar-card/webinar-card.module';
import { FeedCardModule } from '../web/feed-card/feed-card.module';
import { TagUserComponent } from './components/tag-user/tag-user/tag-user.component';
import { ClinicalResourceCardModule } from '../clinical-resource/clinical-resource-card/clinical-resource-card.module';
import { WebDoctalkCardModule } from '../web-doctalk/web-doctalk-list/web-doctalk-section/web-doctalk-card/web-doctalk-card.module';
import { CarouselModule } from 'ngx-owl-carousel-o';


@NgModule({
  declarations: [
    CustomComponentComponent,
    StoryImageComponent,
    MetaGeneratorComponent,
    UserViewsListComponent,
    StoryVideoComponent,
    NoInfoAvailableComponent,
    ProfileBasicHeaderComponent,
    DeleteModalComponent,
    CreationOptionsComponent,
    CreationTextingComponent,
    ProfileHighlighterComponent,
    CustomTemplateComponent,
    MultipleButtonFooterComponent,
    MultiGesturesComponent,
    ThumbnailViewsComponent,
    UserReactionComponent,
    ReactionAnimationComponent,
    UserStoryProductCardComponent,
    TagUserComponent,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    DirectivesModule,
    NgbModalModule,
    NgbModule,
    ModalModule,
    WebinarCardModule,
    FeedCardModule,
    PerfectScrollbarModule,
    InfiniteScrollModule,
    PipesModule,
    ClinicalResourceCardModule,
    WebDoctalkCardModule,
    CarouselModule
  ],
  exports: [
    CustomComponentComponent,
    StoryImageComponent,
    MetaGeneratorComponent,
    UserViewsListComponent,
    StoryVideoComponent,
    NoInfoAvailableComponent,
    ProfileBasicHeaderComponent,
    DeleteModalComponent,
    CreationOptionsComponent,
    CreationTextingComponent,
    ProfileHighlighterComponent,
    CustomTemplateComponent,
    MultipleButtonFooterComponent,
    MultiGesturesComponent,
    ThumbnailViewsComponent,
    UserReactionComponent,
    ReactionAnimationComponent,
    UserStoryProductCardComponent,
    TagUserComponent,
    ModalModule,
    CarouselModule
  ]
})
export class ShareModule { }
